import React, { useState, useEffect } from 'react'
import InputSelectFilterManager from '../InputSelectFilterManager'
import Input from '../Input'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';

const TableListAddStock = () => {
    const { t } = useTranslation()

    const [typeCount, setTypeCount] = useState()
    const [cliet, setClient] = useState()
    const [deposit, setDeposit] = useState()

    const [description, setDescription] = useState()
    const [product, setProduct] = useState()
    const [series, setSeries] = useState()

    const [validate, setValidate] = useState()
    const [productCode, setProductCode] = useState()
    const [manufacture, setManufacture] = useState()

    const [typeStructure, setTypeStructure] = useState()
    const [temperature, setTemperature] = useState()
    const [address, setAddress] = useState()

    const [unitaryValue, setUnitaryValue] = useState()
    const [initialValue, setInitialValue] = useState()
    const [batch, setBatch] = useState()

    /* ERROR MESSAGES */

    const [typeCountError, setTypeCountError] = useState()
    const [clientError, setClientError] = useState()
    const [depositError, setDepositError] = useState()

    const [descriptionError, setDescriptionError] = useState()
    const [productError, setProductError] = useState()
    const [seriesError, setSeriesError] = useState()

    const [validateError, setValidateError] = useState()
    const [productCodeError, setProductCodeError] = useState()
    const [typeStructureError, setTypeStructureError] = useState()

    const [temperatureError, setTemperatureError] = useState()
    const [addressError, setAddressError] = useState()
    const [unitaryValueError, setUnitaryValueError] = useState()

    const [initialValueError, setInitialValueError] = useState()
    const [batchError, setBatchError] = useState()


    const storage = async () => {
        console.log(cliet)

        if (typeCount == undefined) {
            setTypeCountError("informe um tipo de contagem")
        }
        if (cliet == undefined) {
            setClientError("informe um cliente")
        }
        if (deposit == undefined) {
            setDepositError("informe um deposito")
        }
        if (description == undefined) {
            setDescriptionError("informe uma descrição")
        }
        if (product == undefined) {
            setProductError("informe um código de barras")
        }
        if (typeStructure == undefined) {
            setTypeStructureError("informe um tipo de estrutura")
        }
        if (temperature == undefined) {
            setTemperatureError("informe um tipo de temperatura")
        }
        if (address == undefined) {
            setAddressError("informe um endereço")
        }
        if (unitaryValue == undefined) {
            setUnitaryValueError("informe um valor unitario")
        }
        if (initialValue == undefined) {
            setInitialValueError("informe um valor inicial")
        }

        if (typeCount == undefined || cliet == undefined || deposit == undefined ||
            description == undefined || product == undefined || typeStructure == undefined ||
            temperature == undefined || address == undefined || unitaryValue == undefined ||
            initialValue == undefined

        ) {
            return false
        }


        const response = await api.post("countage", {

            "typeCount": typeCount,
            "client": cliet,
            "deposit": deposit,
            "description": description,
            "product": product,
            "batch": batch,
            "series": series,
            "validate": validate,
            "productCode": productCode,
            "manufacture": manufacture,
            "typeStructure": typeStructure,
            "temperature": temperature,
            "address": address,
            "unitaryValue": unitaryValue,
            "initialValue": initialValue

        })

        if (response.status == 200) {

            toast.success('Contagem adicionada com sucesso!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            setTimeout(() => {

                window.location.href = "/dashboard/manager"

            }, [3000])

        }

    }

    useEffect(() => {

        if (typeCount != undefined) {
            setTypeCountError()
        }
        if (cliet != undefined) {
            setClientError()
        }
        if (deposit != undefined) {
            setDepositError()
        }
        if (description != undefined) {
            setDescriptionError()
        }
        if (product != undefined) {
            setProductError()
        }
        if (temperature != undefined) {
            setTemperatureError()
        }
        if (address != undefined) {
            setAddressError()
        }
        if (unitaryValue != undefined) {
            setUnitaryValueError()
        }
        if (initialValue != undefined) {
            setInitialValueError()
        }
        if (typeStructure != undefined) {
            setTypeStructureError()
        }


    }, [typeCount, cliet, deposit, description,
        product, temperature, address,
        unitaryValue, initialValue,
        typeStructure])

    const styleColum1 = {

        width: "100%",
        border: "1px solid #D7D7D7",
        borderRadius: "10px",
        paddingLeft: "21px",
        paddingTop: "25px",
        background: "white",
    }

    const styleColum2 = {

        marginTop: "2.93rem",
        width: "100%",
        height: "480px",
        border: "1px solid #D7D7D7",
        borderRadius: "10px",
        paddingLeft: "21px",
        paddingTop: "25px",
        background: "white",

    }

    const styleRowInputs = {
        display: "flex",
        width: "100%",

    }

    const btnStyle = {

        width: "165px",
        height: "45px",
        borderRadius: "60px",
        background: "#123164",
        border: "none",
        marginTop: "2.18rem",
        marginBottom: "2.18rem",

        outline: "none"

    }


    return (

        <div>
            <ToastContainer />

            <div style={styleColum1}>

                <p className="textPrimaryTableListAddStock">{t('information')}</p>

                <div style={styleRowInputs}>
                    <div style={{ position: "relative" }}>
                        <InputSelectFilterManager type={"typeCountage"} onChange={(e) => setTypeCount(e.target.value)} color="black" custom={true} top={"43px"} width="295px" name={t('countType')} />
                        <p className="errorMessage">{typeCountError != undefined ? typeCountError : <></>}</p>
                    </div>

                    <div style={{ position: "relative" }}>
                        <InputSelectFilterManager error={clientError} onChange={(e) => setClient(e.target.value)} type="client" color="black" custom={true} top={"43px"} width="295px" name={t('client')} />
                        <p className="errorMessage">{clientError != undefined ? clientError : <></>}</p>
                    </div>

                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setDeposit(e.target.value)} color="black" width="295px" marginLeft="8px" height="45px" name={t('deposit')} />
                        <p className="errorMessage">{depositError != undefined ? depositError : <></>}</p>
                    </div>

                </div>

            </div>

            <div style={styleColum2}>

                <p className="textPrimaryTableListAddStock">{t('informationItems')}</p>



                <div style={styleRowInputs}>
                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setDescription(e.target.value)} color="black" type="text" name={t('description')} width="620px" />
                        <p className="errorMessage">{descriptionError != undefined ? descriptionError : <></>}</p>
                    </div>
                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setProduct(e.target.value)} color="black" type="text" marginLeft="20px" name={t('barCode')} width="295px" />
                        <p className="errorMessage" style={{ marginLeft: "20px" }}>{productError != undefined ? productError : <></>}</p>
                    </div>
                </div>

                <div style={styleRowInputs}>
                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setBatch(e.target.value)} color="black" type="text" name={t('batch')} width="167.4px" />
                    </div>

                    <div style={{ position: "relative" }}>
                        <Input mask="9999999999" onChange={(e) => setSeries(e.target.value)} color="black" type="text" name={t('series')} width="167.4px" marginLeft="20px" />
                    </div>

                    <div style={{ position: "relative" }}>
                        <Input mask="99/99/9999" onChange={(e) => setValidate(e.target.value)} color="black" type="text" name={t('validity')} width="167.4px" marginLeft="20px" />
                    </div>

                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setProductCode(e.target.value)} color="black" type="text" name={t('productCode')} width="167.4px" marginLeft="20px" />
                    </div>

                    <div style={{ position: "relative" }}>
                        <Input onChange={(e) => setManufacture(e.target.value)} color="black" type="text" name={t('manufacturing')} width="167.4px" marginLeft="20px" mask={"99/99/9999"} />
                    </div>

                </div>

                <div style={{ marginTop: "2rem" }}></div>
                <div style={styleRowInputs}>
                    <div style={{ position: "relative" }}>
                        <InputSelectFilterManager onChange={(e) => setTypeStructure(e.target.value)} color="black" height={"51px"} top={"47px"} custom={true} type="typeStructure" name={t('typeOfStructure')} width="167.4px" marginLeft="0" />
                        <p className="errorMessage" style={{ marginLeft: "20px" }}>{typeStructureError != undefined ? typeStructureError : <></>}</p>

                    </div>

                    <div style={{ position: "relative" }}>
                        <InputSelectFilterManager onChange={(e) => setTemperature(e.target.value)} color="black" height={"51px"} top={"47px"} custom={true} type="temperature" name={t('temperature')} width="167.4px" />
                        <p className="errorMessage" style={{ marginLeft: "0px", width: "210px" }}>{temperatureError != undefined ? temperatureError : <></>}</p>

                    </div>

                    <div style={{ position: "relative" }}>
                        <Input color="black" onChange={(e) => setAddress(e.target.value)} type="text" name={t('address')} width="167.4px" />
                        <p className="errorMessage" style={{ marginLeft: "0px", width: "210px" }}>{addressError != undefined ? addressError : <></>}</p>

                    </div>

                    <div style={{ position: "relative" }}>
                        <Input color="black" onChange={(e) => setUnitaryValue(e.target.value)} type="text" name={t('UnitaryValue')} width="167.4px" marginLeft="20px" />
                        <p className="errorMessage" style={{ marginLeft: "20px", width: "170px" }}>{unitaryValueError != undefined ? unitaryValueError : <></>}</p>

                    </div>

                    <div style={{ position: "relative" }}>
                        <Input color="black" onChange={(e) => setInitialValue(e.target.value)} type="text" name={t('InitialBalanceSystem')} width="167.4px" marginLeft="20px" />
                        <p className="errorMessage" style={{ marginLeft: "20px", width: "170px" }}>{initialValueError != undefined ? initialValueError : <></>}</p>

                    </div>

                </div>

            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <button className="textBtnTableListStock" style={btnStyle} onClick={() => storage()}>Adicionar estoque</button>
            </div>

        </div>
    )

}

export default TableListAddStock